<template>
  <div class="flex items-center gap-2 p-4 font-bold">
    <span>{{ $t('assetBrowser.upgradeToUnlockFeature') }}</span>
  </div>
</template>
